/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portals_Listing_Extra_Info_NoneInputs */

const cs_portals_listing_extra_info_none = /** @type {(inputs: Portals_Listing_Extra_Info_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Žádný (bez štítku)`)
};

const en_portals_listing_extra_info_none = /** @type {(inputs: Portals_Listing_Extra_Info_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`None (no badge)`)
};

/**
* | output |
* | --- |
* | "None (no badge)" |
*
* @param {Portals_Listing_Extra_Info_NoneInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_listing_extra_info_none = /** @type {((inputs?: Portals_Listing_Extra_Info_NoneInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Listing_Extra_Info_NoneInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_listing_extra_info_none(inputs)
	return cs_portals_listing_extra_info_none(inputs)
});